
<style lang="scss" scoped>
.vslist-detail {
  min-height: 20px;
  padding: 16px;
  margin-bottom: 20px;
  background-color: #f3f7f9;
  border: 1px solid #e4eaec;
  border-radius: 3px;
  width: 80%;
}
.font-14{
    font-size: 14px;
}
.text-center{
    text-align: center;
}
</style>

<template>
    <div>
        <!-- 第一个编辑页面 -->
        <div class="lookitem" v-show="!showTemplate">
            <Breadcrumb class="tablelist-header">
                <BreadcrumbItem>{{$t('global.common.edit',{defaultValue:'编辑'})}}{{$t('global.common.channel',{defaultValue:'店铺'})}}</BreadcrumbItem>
            </Breadcrumb>
            <Alert class="padding-10">
                <span class="tip-p" v-html="$t('fbb.rechage.alert')"></span>
            </Alert>
            <Row class="bg-fff shadow padding-bottom-20">
                <Col span='24'>
                <header class="detail-title">{{$t('global.common.base_information',{defaultValue:'基本信息'})}}</header>
                </Col>
                <Col span='12'>
                <span class="item-label">{{$t('global.common.name',{defaultValue:'名称'})}}：</span>
                <a class="item-content" @click="seeDetail">{{formData.name}}</a>
                </Col>
                <Col span='12'>
                <span class="item-label">{{$t('global.common.project',{defaultValue:'项目'})}}：</span>
                <span class="item-content">{{formData.lineId|transferText('name',products)}}</span>
                </Col>
                <Col span='12'>
                <span class="item-label">ERPSKU：</span>
                <span class="item-content">{{formData.erpSku}}</span>
                <!-- <Button @click="seeDetail">查看详细信息</Button> -->
                </Col>
                <Col span='24'>
                <Form :label-width="100" ref="form">
                    <section v-for="(item,index) in svRules" class="clearfix" :key="index">
                        <header class="item-label">{{item.stockGroupName}}</header>
                        <section class="item-content vslist-detail">
                            {{$t('erp.virtualstore.setusestores',{defaultValue:'设定可用店铺'})}}:
                            <div style="margin-left:100px;">
                                <Transfer
                                    :data="accountsTarget"
                                    :target-keys="ruleAccounts[index].targelist"
                                    :list-style="listStyle"
                                    filterable
                                    :filter-method="filterMethod"
                                    @on-change="(targetKeys)=>{handleStoreChange(targetKeys,index,item.id,svRules)}">
                                </Transfer>
                            </div>
                        </section>
                    </section>
                </Form>
                </Col>
                <Col span="24" class="text-center padding-10">
                <!-- <Button type="primary" class="width-15per" @click="routeBack">上一步</Button> -->
                <Button type="primary" class="width-15per" @click="nextStep">{{$t('fbb.accountmanage.next_step',{defaultValue:'下一步'})}}</Button>
                <Button class="width-15per" @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
                </Col>
            </Row>
        </div>
        <!-- 查看信息按钮 -->
        <Modal
        class="hidefooter"
        v-model='operatedetail.show'
        :mask-closable='false'
        v-bind="operatedetail">
            <component :is="operatedetail.component" @on-close="operatedetail={}" v-bind="operatedetail" v-if="operatedetail.show"/>
            <footer slot="footer" v-show="false"></footer>
        </Modal>
        <!-- 弹框 -->
        <Modal
            v-model="operate.show"
            :title="operate.title"
            @on-ok="ok"
            @on-cancel="close"
            :okText="operate.oktext"
            :cancel-text="operate.canceltext">
            <p class="font-14 text-center">{{operate.content}}</p>
        </Modal>
        <Modal
            v-model="alertbox.show"
            :title="alertbox.title"
            footer-hide>
            <p class="font-14 text-center margin-30">{{alertbox.content}}</p>
        </Modal>
        <!-- 展示模板页面 -->
        <div class="clearfix" v-show="showTemplate">
            <Breadcrumb class="tablelist-header">
                <BreadcrumbItem to="/">{{$t('erp.virtualstore.edittemplate',{defaultValue:'编辑模板'})}}</BreadcrumbItem>
            </Breadcrumb>
            <Alert class="padding-10">
                <span class="tip-p" v-html="$t('fbb.rechage.alert')"></span>
            </Alert>
            <div class="bg-fff shadow padding-bottom-15" >
                <header class="detail-title">{{$t('global.common.base_information',{defaultValue:'基本信息'})}}</header>
                <Form :label-width="120" ref="form" class="splitline padding-right-15" style='max-width:600px'>
                    <FormItem prop="templateName" :label="$t('fbb.accountmanage.template_name',{defaultValue:'模板名称'})" :rules="required">
                        <Input v-model="everyTemplate.templateName"></Input>
                    </FormItem>
                    <FormItem :label="$t('global.common.project',{defaultValue:'项目'})">
                        <span>{{everyTemplate.lineId|transferText('name',products)}}</span>
                    </FormItem>
                    <FormItem label='ERP SKU'>
                        <span>{{everyTemplate.erpSku}}</span>
                    </FormItem>
                    <FormItem :label="$t('erp.virtualstore.description',{defaultValue:'模板描述'})" :rules="required">
                        <Input v-model="everyTemplate.description" type='textarea'></Input>
                    </FormItem>
                </Form>
                <header class="detail-title">{{$t('erp.virtualstore.distributionnews',{defaultValue:'分配信息'})}} <span v-show="finishSubmit"><Button type="primary" @click="copyModel">{{$t('global.common.copy',{defaultValue:'复制'})}}</Button> {{$t('erp.virtualstore.nowscopynext',{defaultValue:'当前模板比例值复制到后续模板'})}}</span> <span class="pull-right margin-right-20 font-14">{{$t('erp.virtualstore.now_allpage',{defaultValue:'当前页数/总页数'})}}: <span class="color-error">{{tempIndex+1}}</span>/{{templateArray.length}} </span></header>
                <Table
                :key="tempIndex"
                class="margin-10"
                :columns="columns"
                :data="formAllotList"
                size="small"
                ref="table"
                border
                stripe>
                <footer slot="footer" class="clearfix">
                    <span style="width:330px;" class="pull-left padding-left-20">{{$t('erp.b2c.product_totalcount',{defaultValue:'合计'})}}</span>
                    <span class="pull-left">{{assignPercentTotal}}</span>
                </footer>
                </Table>
                <footer class="text-center">
                    <Button type="primary" class="width-15per" @click="lastEditChannel" v-show="showEditChannel">{{$t('erp.virtualstore.laststep',{defaultValue:'上一步'})}}</Button>
                    <Button type="primary" class="width-15per" @click="lastTemplate" v-show="showLastTemp">{{$t('erp.virtualstore.laststep',{defaultValue:'上一步'})}}</Button>
                    <Button type="primary" class="width-15per" @click="nextTemplate" v-show="showNextTemp">{{$t('fbb.accountmanage.next_step',{defaultValue:'下一步'})}}</Button>
                    <Button type="primary" @click="nowFinish" class="width-15per" v-show="finishSubmit">{{$t('erp.virtualstore.skipforce',{defaultValue:'跳过并强制完成'})}}</Button>
                    <Button type="primary" @click="submit" class="width-15per" v-show="showSubmit">{{$t('erp.distribution.confirm_submit',{defaultValue:'提交'})}}</Button>
                    <Button @click="cancel" class="width-15per">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
                </footer>
            </div>
        </div>
        <!-- 弹框 -->
        <Modal
            v-model="finish.show"
            :title="finish.title"
            @on-ok="submit()"
            @on-cancel="finishclose"
            :okText="finish.oktext"
            :cancel-text="finish.canceltext">
            <p>{{$t('erp.b2c.order_attention',{defaultValue:'注意'})}}： </p>
            <p>{{$t('erp.virtualstore.attention_temp1',{defaultValue:'点击确认按钮前，请检查每个分配模板的比例都已维护正确！可采取手工逐页维护或复制功能！'})}}</p>
            <p>{{$t('erp.virtualstore.attention_temp2',{defaultValue:'若不维护就点击确认按钮：则新增的渠道按0%保存；移除的渠道其移除比例不会自动处理，原有渠道只按原维护比例保存。'})}}  </p>
        </Modal>
        <Modal
            v-model="copybtn.show"
            :title="copybtn.title"
            @on-ok="copyTemp()"
            @on-cancel="finishclose"
            :okText="copybtn.oktext"
            :cancel-text="copybtn.canceltext">
            {{copybtn.content}}
        </Modal>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
import { mapState,mapGetters } from 'vuex'
import {
    HttpVsDetail, HttpGetTemplate, HttpEditorChannel
} from '@/service/boss/allot';
import compDetail from './detail';
export default {
    components: {
        compDetail
    },
    data() {
        return {
            loading: false,
            headid: this.$route.params.id,
            svRules: [],
            sourceData:'',
            formData: {
                name: '',
                lineId: '',
                erpSku: '',
                rules: [],
                stockGroups: [],
                organizationWarehouses: [],
                description: '',
                productId: '',
            },
            listStyle: {
                width: "39%",
                height: '300px',
            },
            ruleAccounts: [],
            newruleAccounts:[],
            operate: {
				title: "",
				show: false,
                oktext: '',
                canceltext: '',
                content:"",
                showbox:false,
            },
            alertbox: {
				title: "",
				show: false,
                content:"",
                showbox:false,
            },
            finish: {
				title: "",
				show: false,
                oktext: '',
                canceltext: '',
                content:"",
            },
            bounced:false,
            // 展示模板的逻辑
            showTemplate:false,
            assignPercentTotal: 0,
            tempFromData:{
                stockVirtualGroupRuleId: "",
				templateName: "",
				description: "",
				lineId: "",
				erpSku: "",
            },
            formAllot:[],
            required: [{
				required: true,
				message: this.$t('global.common.required',{defaultValue:'该信息不能为空,请填写'}),
				trigger: 'blur'
			}],
            // 装的是现阶段每个模板模板里面现有的渠道array
            nowChannelArray:[],
            // 装的是遍历之后的每个模板array
            templateArray:[],
            booleadArray:[],
            editruleAccounts:[],
            resDataes:'',
            tempIndex:0,
            everyTemplate:{
                templateName:'',
                lineId: '',
                erpSku: '',
                description: '',
            },
            showEditChannel:false,
            showLastTemp:false,
            showNextTemp:true,
            finishSubmit:false,
            showSubmit:false,
            // 每次修改模板之后的存储数组
            storeChannel:[],
            operatedetail: {
                id: null,
                title: "",
                show: false,
                component: null
            },
            copybtn:{
                title: "",
				show: false,
                oktext: '',
                canceltext: '',
                content:"",
            },
            // 复制全部模板的变量
            nowTempid:'',
            judge:false,
            channelFormData:[],
        }
    },
    created() {
        this.getDetail();
        this.$on('on-total', this.getTotal)
    },
    computed: {
        ...mapState('boss',['products', 'accounts']),
        ...mapGetters('boss',['warehouses']),
        accountsTarget() {
            return this.accounts.map((item) => {
                const bool=item.status === 'inactive';
                return {
                    label: bool?`${item.title}(${item.flag})<span class='color-error'>(`+this.$t('global.common.inactive',{defaultValue:'停用'})+`)</span>`:`${item.title}(${item.flag})`,
                    key: item.id,
                    // disabled:bool

                }
            }) 
        },
        formAllotList(){
            const data = []; 
            const data2 = [];
            // console.log(this.formAllot,'11111')
                // console.log(this.ruleAccounts,'22222')
            this.formAllot.forEach((item,index)=>{
                this.ruleAccounts.filter(item=>{return item.temppid == this.everyTemplate.stockVirtualGroupRuleEntity.id})[0].targelist.forEach((id)=>{
                    // console.log(id,item.accountId)
                    if(id==item.accountId){
                        data.push(item);
                    }else{
                        this.accounts.forEach((item)=>{
                            if(id==item.id){
                                // 匹配id成功的，返回name，键值对，赋值给谁为0
                                const dataitem = {
                                    accountFlag:item.flag,
                                    accountId:item.id,
                                    assignPercent:0,
                                    adjustValue:0,
                                    safeQuantity:0
                                }
                                data2.push(dataitem)
                            }
                        })
                    }
                })
            })
            // 去重数组中的对象  AEGF03B
            const alldata = data.concat(this.arrayUnique(data2,"accountId"))
            // console.log(data,data2)
            const asas = this.arrayUnique(alldata,"accountId")
            // console.log(asas,'alldata3333333')
            const alldatas = asas.map(itemjson=>{
                // console.log(itemjson)
                return {
                    accountFlag : itemjson.accountFlag,
                    accountId : itemjson.accountId,
                    adjustValue : itemjson.adjustValue,
                    assignPercent : itemjson.assignPercent,
                    safeQuantity : itemjson.safeQuantity,
                }
            })
            // console.log(alldatas)
            return alldatas;

        },
        columns() {
			return [{
				title: this.$t('global.common.channel',{defaultValue:'店铺'}),
				key: 'accountFlag',
				width: 300,
			}, {
				title: this.$t('erp.virtualstore.assignPercent',{defaultValue:'分配比例'}),
				render: (h, { row, index }) => {
					return this.changeAllot(h, 'assignPercent', row, index, { min: 0, max: 100 });
				}
			}, {
				title: this.$t('erp.virtualstore.adjustValue',{defaultValue:'调整值'}),
				render: (h, { row, index }) => {
					return this.changeAllot(h, 'adjustValue', row, index);
				}
			}, {
				title: this.$t('erp.virtualstore.safeQuantity',{defaultValue:'安全库存'}),
				render: (h, { row, index }) => {
					return this.changeAllot(h, 'safeQuantity', row, index, { min: 0 });
				}
			}]
		},
    },
    methods: {
        // 查看页面
            seeDetail(){
            this.operatedetail = {
                id:this.headid,
                title: this.$t('global.common.query',{defaultValue:'查看'}),
                component: 'compDetail',
                show: true,
                width: 760,

            }
        },
        // 去重数组
        arrayUnique(arr, name) {
            var hash = {};
            return arr.reduce((item, next)=>{
                hash[next[name]] ? '' : hash[next[name]] = true && item.push(next);
                return item;
            }, []);
        },
        // 根据传入id删除数组对应的对象
        arrayDelete(arr, id) {
            for(var i = arr.length-1;i>-1;i--){
                if(arr[i].tempid == id){
                    arr.splice(i,1);
                }
            }
            // console.log(arr)
        },
        // 根据某个字段进行数组的排序
        compare(property){
            return function(a,b){
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        },
        ok(){
            if(this.bounced===false){
                this.$router.push({ name: "vstorelist" })
            }else{
                const databases = {
                    orgId: this.resDataes.orgId,
                    groupId: parseInt(this.headid),
                    list: this.editruleAccounts,
                }
                HttpEditorChannel(databases).then(res => {
                    this.loading = false;
                    // this.$Message.success(res.message);
                },err => {
                    this.loading = false;
                    this.errorMessage(err.message);
                });
                this.$router.push({ name: "saTemplate" })
            }
        },
        close(){
            this.operate.show = false;
            if(this.operate.showbox == true){
                const databases = {
                    orgId: this.resDataes.orgId,
                    groupId: parseInt(this.headid),
                    list: this.editruleAccounts,
                }
                HttpEditorChannel(databases).then(res => {

                    this.loading = false;
                    this.$Message.success(res.message);
                    this.$router.push({ name: "vstorelist" })
                }, err => {
                    this.loading = false;
                    this.errorMessage(err.message);
                })
            }
        },
        async getDetail() {
            this.loading = true;
            HttpVsDetail({
                id: this.headid
            }).then(res => {
                this.resDataes = res.data
                this.handleResponse(res.data);
                this.formData.rules = res.data.stockVirtualGroupRules.sort(this.compare('stockGroupId'));
                this.handleDataform(this.formData)
                this.loading = false;
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                    });
                this.loading = false;
            });
        },
        handleStoreChange(targetKeys, index, temppid, svRules) {
            // console.log(svRules)
            this.$set(this.ruleAccounts, index, {temppid:temppid,targelist:targetKeys});
            var arr = [],tips = [],itemflag;
            
            targetKeys.forEach(key=>{
                this.accounts.map(json=>{
                    if(key==json.id){
                        itemflag = json
                    }
                })
                this.ruleAccounts.forEach((item,i)=>{
                    if(index == i) return;
                    var bool = item.targelist.includes(key)
                    if(bool){
                        tips.push(`${svRules[index].stockGroupName}与${svRules[i].stockGroupName}有相同店铺${itemflag.title}(${itemflag.flag})`)
                    }
                })
                // console.log(this.ruleAccounts,'this.ruleAccounts')
            })
            if(tips.length>0){
                this.alertbox = {
                    title: this.$t('erp.aftersales.attention',{defaultValue:'提示'}),
                    show: true,
                    content:tips.join(','),
                    showbox:false,
                }
                // this.$Message.error(tips.join(','))
            }

            this.accounts.map( json=>{
                targetKeys.map(item =>{
                    if( item == json.id ){
                        arr.push(item)
                    }
                })
            })
            this.ruleAccounts[index] = {temppid:temppid,targelist:arr}
            
            this.handleEditChanggel(temppid)
        },
        // 处理编辑渠道的目的列表
        handleEditChanggel(temppid){
            const data = [];
            const data2 = [];
            // let Tempid = this.resDataes.stockVirtualGroupRules[index].id
            // console.log(this.ruleAccounts,'this.ruleAccounts',temppid,this.resDataes)
            this.ruleAccounts.filter(json=>{return json.temppid == temppid})[0].targelist.map( item => {
                let aitem = this.resDataes.stockVirtualGroupRules.filter(item=>{return item.id == temppid})[0]
                // console.log(aitem,'989898')
                if(aitem.stockVirtualGroupRuleAccountEntity.length>0){
                    const bbbjson = aitem.stockVirtualGroupRuleAccountEntity.map(json =>{
                        // console.log(json)
                        if(json.accountId == item){
                            data.push(json)
                        }else {
                            this.accounts.forEach((jsones)=>{
                                if(item == jsones.id){
                                    // 匹配id成功的，返回name，键值对，赋值给谁为0
                                    const dataitem = {
                                        accountFlag:jsones.flag,
                                        accountId:jsones.id,
                                    }
                                    data2.push(dataitem)
                                }
                            })
                        }
                    })
                }else{
                    this.accounts.forEach((jsones)=>{
                        if(item == jsones.id){
                            // 匹配id成功的，返回name，键值对，赋值给谁为0
                            const dataitem = {
                                accountFlag:jsones.flag,
                                accountId:jsones.id,
                            }
                            data2.push(dataitem)
                        }
                    })
                }
            })
             // 去重数组中的对象
            const alldata = data.concat(this.arrayUnique(data2,"accountId"))
            const alldatas = this.arrayUnique(alldata,"accountId")
            // console.log(alldata,alldatas,'131231312')
            const list = {
                id:temppid,
                accounts:alldatas
            }
            // console.log(this.editruleAccounts,'this.editruleAccounts')
            // return
            // 先删除现有的再添加新的
            for(var i = this.editruleAccounts.length-1;i>-1;i--){
                if(this.editruleAccounts[i].id == temppid){
                    this.editruleAccounts.splice(i,1);
                }
            }
            this.editruleAccounts.push(list)
        },
        handleResponse(data = {}) {
            // console.log(data)
            let {name, lineId, erpSku, description, productId, stockVirtualGroupRules = []} = data;
            let organizationWarehouses = (stockVirtualGroupRules[0] || {}).stockVirtualGroupRuleItemEntity || [],
                stockGroups = stockVirtualGroupRules.map(item => {
                    return item.stockGroupId;
                });
            organizationWarehouses = organizationWarehouses.map(item => {
                return item.orgWarehouseId;
            });
            this.formData = {name, lineId, erpSku, description, productId, organizationWarehouses, stockGroups};

        },
        handleDataform(data) {
            let { name, lineId, erpSku, description, status } = data;
            this.formData = { name, lineId, erpSku, description, status };
            this.svRules = (data.stockGroups || []).sort(function(pre,cur){
                return pre>cur?1:-1
            }).map((item, index) => {
				// console.log(item)
                let accountslist = data.rules.filter((items) => {
                    return items.stockGroupId == item;
                });
                if (accountslist.length > 0) {
                    accountslist = accountslist[0].stockVirtualGroupRuleAccountEntity;
                }
                
                let rule = data.rules.filter((items) => {
                    return items.stockGroupId == item;
                })[0];
                if (!rule) {
                    rule={};
                    rule.stockGroupId = item;
                    if (item == 1) {
                        rule.stockGroupName = 'T1'
                    }
                    if (item == 2) {
                        rule.stockGroupName = 'T2'
                    }
                    if (item == 3) {
                        rule.stockGroupName = 'T3'
                    }
                    if (item == 4) {
                        rule.stockGroupName = 'T4'
                    }
                    if (item == 5) {
                        rule.stockGroupName = 'T5'
                    }
                }

                rule.stockVirtualGroupRuleAccountEntity = accountslist;
                // this.ruleAccounts[index] = {temppid:temppid,targelist:arr}
                
                this.$set(this.ruleAccounts, index, {tempid:rule.id,targelist:rule.stockVirtualGroupRuleAccountEntity.map(json => {
                    return json.accountId;
                }).filter( id =>{
                    return this.accountsTarget.some(item=>{
                        return item.key == id
                    })
                })}
                );
                this.$set(this.nowChannelArray, index, {tempid:rule.id,targelist:rule.stockVirtualGroupRuleAccountEntity.map(json => {
                    return json.accountId;
                }).filter( id =>{
                    return this.accountsTarget.some(item=>{
                        return item.key == id
                    })
                })});
                // console.log(this.ruleAccounts,'this.ruleAccounts')
                return rule;
            });
        },
        compareFN(x, y) {//比较函数
            if (x < y) {
                return -1;
            } else if (x > y) {
                return 1;
            } else {
                return 0;
            }
        },
        // 下一步展示到模板页面
        nextStep(){
            const _this = this;
            // 每个下面的渠道不能为空
            // console.log(this.ruleAccounts,'this.ruleAccounts')
            const has = this.ruleAccounts.every(val => {
                return val.targelist.length > 0
            });
            if (!has) {
                this.$Message.warning(this.$t('global.common.choose',{defaultValue:'请选择'})+this.$t('global.common.channel',{defaultValue:'店铺'}));
                return false;
            }

            var ruleAccounts = this.ruleAccounts.concat();
            var nowChannelArray = this.nowChannelArray.concat();

            const complex=function(arr,arr2){
                if(arr.length!=arr2.length) return true;
                return arr.some(function(val){
                    return !(arr2.indexOf(val)>-1);
                });
            }
            
            this.bounced = ruleAccounts.some(function(arr,index){
                return complex(arr.targelist,nowChannelArray[index].targelist)
            })
            // console.log(this.ruleAccounts,'this.bounced')

            // 判断数组中有没有重复的值
            var arrayA = this.ruleAccounts.concat();
            arrayA = arrayA.map(item=>{
                return item.targelist
            })
            // var arrayB = this.nowChannelArray.concat();
            let isRepeat;
            // console.log(arrayA)
            let arule = arrayA.sort().toString().split(",").sort().toString();
            
            var isarray = arule.split(",")
            // console.log(isarray)
            for(let i = 0; i<isarray.length;i++){
                if(isarray[i] == isarray[i+1]){
                    isRepeat = true
                }
            }
            // console.log(this.nowChannelArray)
            this.booleadArray = this.nowChannelArray.map((item,index) => {
                if(item.targelist.toString()==_this.ruleAccounts[index].targelist.toString()){
                    // 没有改动
                    return {flag:true,itemone:item}
                } else {
                    // 有修改的
                    return {flag:false,itemone:item}
                }
            })
            // return 
            // console.log(this.booleadArray,'this.booleadArray')

            if(this.bounced===false){
                this.operate = {
                    title: this.$t('erp.aftersales.attention',{defaultValue:'提示'}),
                    show: true,
                    content:this.$t('erp.virtualstore.noeditanynews',{defaultValue:'您没有修改任何信息'}),
                    oktext: this.$t('global.modal.confirm',{defaultValue:'确定'}),
                    canceltext: this.$t('global.common.operation_cancel',{defaultValue:'取消'}),
                    showbox:false,
                }
            }else{
                if(isRepeat==true){
                    this.$Message.error(this.$t('erp.virtualstore.nodoublestore',{defaultValue:'T级下不能有重复的店铺'}));
                    return
                }
                // 获取这个id下所有的模板
                HttpGetTemplate({
                    id: this.headid
                })
                .then( res => {
                    let dataarr = [...res.data]
                    this.loading = false;
                    if(res.data.length<1){
                        this.operate = {
                            title: this.$t('erp.aftersales.attention',{defaultValue:'提示'}),
                            show: true,
                            content:this.$t('erp.virtualstore.nohaveallocatemp',{defaultValue:'您没有相对应的二层分配模板'}),
                            oktext: this.$t('erp.virtualstore.tosetup',{defaultValue:'前往设置'}),
                            canceltext: this.$t('erp.virtualstore.savenownptosetup',{defaultValue:'保存当前数据，不前往设置'}),
                            showbox:true,
                        }
                    }else{
                        // 展示模板页面和上一步,每次初始化一下数组
                        this.templateArray = []
                        this.handleTemplate(dataarr)
                    }
                },
                    err => {
                        this.loading = false;
                        this.errorMessage(err.message);
                    }
                )}

        },
        // 上一步展示编辑渠道
        lastEditChannel(){
            this.showTemplate = false;
        },
        // 模板展示的逻辑
        handleTemplate(data) {
            // console.log(data,'66666')
            const _this = this;
            data ? data : {};
            this.showTemplate = true;
            // 找到对应改变的数组是谁
            // console.log(this.booleadArray,'55555')
            this.booleadArray.map((item,jsonone) => {
                if(item.flag==false){
                    data.map((arr,arIndex) => {
                        if(arr.stockVirtualGroupRuleEntity.id == item.itemone.tempid){
                            this.templateArray.push(arr)
                        }
                    })
                    // this.newruleAccounts = this.ruleAccounts[jsonone] || [];
                }
            })
            // console.log(this.templateArray,'4444444')
            // return 
            if(this.templateArray.length!==0){
                if(this.templateArray.length == 1){
                    this.showNextTemp = false;
                    this.showSubmit = true;
                    this.finishSubmit = false;
                    this.showEditChannel = true;
                }else{
                    this.showNextTemp = true;
                    this.showSubmit = false;
                    this.finishSubmit = true;
                    this.showEditChannel = true;
                }

            //     // 默认展示第一个模板
                this.everyTemplate = this.templateArray[this.tempIndex];
                this.formAllot = this.everyTemplate.stockTemplateItems;
                this.nowTempid = this.everyTemplate.stockVirtualGroupRuleEntity.stockGroupId                
                // 初始化默认的百分比
                this.assignPercentTotal = this.formAllotList.reduce((pre, next, index, array) => {
                    return pre + next.assignPercent;
                }, 0)

                // 在这里把全部获取的模板里面的渠道进行修改跟选择后的渠道一样
                // 1
                _this.templateArray.map(function(item){
                    item.stockTemplateItems.map(function(json,index){
                        var status = false;
                        _this.formAllotList.map(function(data){
                            if(json.accountId == data.accountId){
                                status = true
                            }
                        })
                        // if(!status){
                        //     item.stockTemplateItems.splice(index,1)
                        // }
                    })
                })
                
            }else{
                this.showTemplate = false;
                this.operate = {
                    title: this.$t('erp.aftersales.attention',{defaultValue:'提示'}),
                    show: true,
                    content:this.$t('erp.virtualstore.nohaveallocatemp',{defaultValue:'您没有相对应的二层分配模板'}),
                    oktext: this.$t('erp.virtualstore.tosetup',{defaultValue:'前往设置'}),
                    canceltext: this.$t('erp.virtualstore.savenownptosetup',{defaultValue:'保存当前数据，不前往设置'}),
                    showbox:true,
                }
            }
            

        },
        getTotal() {
			this.assignPercentTotal = this.formAllotList.reduce((pre, next, index, array) => {
				return pre + next.assignPercent;
			}, 0)
        },
        // 改变比例值的方法
        changeAllot(h, key, row, index, prop = {}) {
			return h('InputNumber', {
				key,
				props: {
					...prop,
					value: row[key]
				},
				on: {
					'input': (value) => {
						this.formAllotList[index] = { ...this.formAllotList[index], [key]: value };
						this.$emit('on-total')
					},
				}
			})
        },
        // 点击复制按钮
        copyModel(){
            this.copybtn = {
                title: this.$t('erp.aftersales.attention',{defaultValue:'提示'}),
				show: true,
                oktext: this.$t('global.modal.confirm',{defaultValue:'确定'}),
                canceltext: this.$t('global.common.operation_cancel',{defaultValue:'取消'}),
                content:this.$t('erp.virtualstore.confirmtemplate',{defaultValue:'确认当前模板比例值复制到后续模板？'}),
            }
        },
        // 按确定之后调用
        copyTemp(){
            // 当前的数据后续相同的模板一起修改
            for(let i = this.tempIndex+1;i<this.templateArray.length;i++){
                if(this.nowTempid == this.templateArray[i].stockVirtualGroupRuleEntity.stockGroupId){
                    this.templateArray[i].stockTemplateItems = this.formAllotList
                }
            }
            this.$Message.success(this.$t('global.common.copy',{defaultValue:'复制'})+this.$t('erp.managewarehouse.operate_success',{defaultValue:'成功'}));

        },
        
        // 展示上一个模板
        lastTemplate(){
            this.tempIndex -= 1;
            if(this.tempIndex<this.templateArray.length){
                if(this.tempIndex==0){
                    this.showEditChannel = true;
                    this.showLastTemp = false;
                    this.showNextTemp = true;
                    this.showSubmit = false;
                    this.finishSubmit = true;
                }else{
                    this.showLastTemp = true;
                    this.showNextTemp = true;
                    this.showSubmit = false;
                    this.finishSubmit = true;
                }
                this.everyTemplate = this.templateArray[this.tempIndex];
                this.formAllot = this.everyTemplate.stockTemplateItems;
                this.nowTempid = this.everyTemplate.stockVirtualGroupRuleEntity.stockGroupId
                // 初始化默认的总百分比
                this.assignPercentTotal = this.formAllotList.reduce((pre, next, index, array) => {
                    return pre + next.assignPercent;
                }, 0)
            }
        },
        // 展示下一个模板
        nextTemplate(){
            // 获取上一次编辑模板最后的值

            // 每次编辑的时候传当前的值给总的templateArray 上一次编辑的值进行传值修改
            this.templateArray[this.tempIndex].stockTemplateItems = this.formAllotList
            // console.log(this.templateArray,'23423423')
            // 关闭上一步编辑渠道
            this.showEditChannel = false;
            this.tempIndex += 1;
            // 
            // console.log(this.formAllotList,'ssss')
            if(this.tempIndex<this.templateArray.length){
                if((this.tempIndex+1)==this.templateArray.length){
                    this.showNextTemp = false;
                    this.showLastTemp = true;
                    this.showSubmit = true;
                    this.finishSubmit = false;

                }else{
                    this.showLastTemp = true;
                    this.showNextTemp = true;
                    this.showSubmit = false;
                    this.finishSubmit = true;
                }
                this.everyTemplate = this.templateArray[this.tempIndex];
                
                this.formAllot = this.everyTemplate.stockTemplateItems || [];
                this.nowTempid = this.everyTemplate.stockVirtualGroupRuleEntity.stockGroupId
                // 初始化默认的总百分比
                this.assignPercentTotal = this.formAllotList.reduce((pre, next, index, array) => {
                    return pre + next.assignPercent;
                }, 0)
                
            }
        },
        // 点击完成的提交
        nowFinish(){
            this.finish = {
                title: this.$t('erp.aftersales.attention',{defaultValue:'提示'}),
                show: true,
                oktext: this.$t('global.modal.confirm',{defaultValue:'确定'}),
                canceltext: this.$t('global.common.operation_cancel',{defaultValue:'取消'}),
            }
        },
        finishclose(){
            this.finish.show = false;
            this.copybtn.show = false;
        },
        
        // 提交&完成
        submit(value) {
            this.judge = false;
            this.formAllotList.map(item=>{
                if(item.assignPercent==null || item.adjustValue==null || item.safeQuantity==null){
                    this.judge = true;
                }
            })
            if(this.judge == true){
                this.$Message.error(this.$t('erp.virtualstore.nullnumber',{defaultValue:'数值不能为空'}));
                this.loading = false;
            }else{
                
                this.templateArray[this.tempIndex].stockTemplateItems = this.formAllotList
                this.storeChannel = this.templateArray.map(item=>{
                    return {
                        id:item.stockVirtualGroupRuleEntity.id,
                        tempid:item.id,
                        accounts:item.stockTemplateItems,
                        template:{
                            id:item.id,
                            erpSku:item.erpSku,
                            orgId:item.orgId,
                            lineId:item.lineId,
                            stockVirtualGroupRuleId:item.stockVirtualGroupRuleEntity.id,
                            templateName:item.templateName,
                            description:item.description,
                            stockTemplateItems:item.stockTemplateItems
                        },
                    }
                })
                
                const databases = {
                    orgId: this.everyTemplate.orgId,
                    groupId: parseInt(this.headid),
                    list: this.storeChannel,
                }
                HttpEditorChannel(databases).then(res => {
                    this.loading = false;
                    this.$Message.success(res.message);
                    this.$router.push({ name: "vstorelist" })
                },err => {
                    this.errorMessage(err.message);
                    this.loading = false;
                	
                });
            }
        },
        // 添加自定义搜索函数,不区分大小写
        filterMethod (data, query) {
            return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        },
        // 取消
        cancel() {
            this.$router.push({ name: "vstorelist" })
        },
    }
}
</script>

